import { render, staticRenderFns } from "./SalesPrice.vue?vue&type=template&id=ffa74a5e&"
import script from "./SalesPrice.vue?vue&type=script&lang=js&"
export * from "./SalesPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports